module.exports = "https://static.wanderu.com/static/media/tech-crunch.82a5cb7b.png";